import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
// import Footer from '../components/Footer';
import logo from "../assests/logo.png";
const ThankYou = () => {
  useEffect(() => {
    window.gtag("event", "conversion", {
      send_to: "AW-11394525449/z_RQCNCDj_IYEInSqrkq",
    });

    window.gtag("event", "conversion", {
      send_to: "AW-10896336864/4MZqCMP1xYgYEODP48so",
    });

    window.gtag('config', 'AW-11394525449/AaISCM3S5fsYEInSqrkq', {
      'phone_conversion_number': '7583837705'
    });
  }, []);
  return (
    <>
      <Navbar />
      <section>
        <div className="vh-100 d-flex justify-content-center align-items-center">
          <div className="col-md-4">
            <div className="border border-3 border-primary"></div>
            <div className="card  bg-white box-shadow p-5">
              <div className="mb-4 text-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-success"
                  width="75"
                  height="75"
                  fill="currentColor"
                  //   className="bi bi-check-circle"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                </svg>
              </div>
              <div className="text-center">
                <h1>Thank You !</h1>
                <p>
                  Thank You for showing interest, our expert will contact you
                  soon.
                </p>
                <Link to="/">
                  <button className="btn btn-outline-primary">Back Home</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer className="footer-startup">
        <section className="bg-gray-v2">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 mb-5 mb-lg-0">
                <img src={logo} alt="Premisin" />
                <p className="u-mt-40 mb-0">
                  We believe in revolutionizing your space just the way you
                  want, liberating our reach to your comfort. Premisin offers
                  facilities that are spacious, accessible and comfortable for
                  the benefit of our society.
                </p>
              </div>
              <div className="col-lg-3 col-md-6 ml-auto mb-5 mb-lg-0">
                <h4>Contact Info</h4>
                <div className="u-h-4 u-w-50 bg-primary rounded mt-3 u-mb-40"></div>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2">
                    <span className="icon icon-Phone2 text-primary mr-1">
                      <i className="fa fa-phone  text-primary mr-1 pt-1"></i>
                    </span>
                    <a
                      onClick={() => {
                        window.gtag("event", "bottom_button_click_call");
                        window.gtag_report_conversion('tel:7583837705');
                      }}
                      href="tel:7583837705"
                    >
                      758383 7705
                    </a>
                  </li>
                  <li className="mb-2">
                    <span class="icon icon-Mail text-primary mr-1">
                      <i
                        className="fa fa-envelope text-primary mr-1 pt-1"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <a
                      onClick={() => {
                        window.gtag_report_conversion('mailto:info@premisin.com');
                      }}
                      href="mailto:info@premisin.com"
                      fa
                      fa-map-marker
                    >
                      info@premisin.com
                    </a>
                  </li>
                  <li className="mb-0">
                    <span className="icon icon-Pointer text-primary mr-2">
                      <i
                        className="fa fa-map-marker text-primary mr-1 pt-1"
                        aria-hidden="true"
                      ></i>
                    </span>
                    C-240/245/246, Vallabh Nagar, Near St. Gyaneshawar School
                    Raipur, Chhattisgarh- 492001
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-6 ml-auto mb-0 mb-lg-0">
                <h4>Connect With Us</h4>
                <div className="u-h-4 u-w-50 bg-primary rounded mt-3 u-mb-40"></div>
                <ul className="list-inline social social-rounded social-white mt-4 mb-0">
                  <li className="list-inline-item">
                    <a
                      onclick="called_phone_gads_track();"
                      href="https://www.facebook.com/premisin/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      onclick="called_phone_gads_track();"
                      href="https://twitter.com/premisin/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      onclick="called_phone_gads_track();"
                      href="https://www.instagram.com/premisin_coworking_space"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      onclick="called_phone_gads_track();"
                      href="https://www.linkedin.com/in/premisin/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fa fa-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="u-py-20">
          <div className="container">
            <p className="mb-0 text-center">
              Premisin &copy; 2023 - All Rights Reserved.
            </p>
          </div>
        </section>
      </footer>

      <div className="call-nav  box-shadow-v2">
        <a
          onClick={() => {
            window.gtag("event", "bottom_button_click_call");
            window.gtag_report_conversion('tel:7583837705');
          }}
          href="tel:7583837705"
        >
          <i className="fa fa-phone text-white" aria-hidden="true"></i>
          <span type="button" className="d-none">7583837705</span>
        </a>
      </div>

      <div className="  box-shadow-v2">
        <a
          href="/"
          data-toggle="modal"
          data-target="#sidenavmail"
          onclick={(e) => {
            e.preventDefault()
          }}
        >
          <i className="fa fa-envelope " aria-hidden="true"></i>
        </a>
      </div>
    </>
  );
};

export default ThankYou;
